export function mapPostOptionsToFields (postOpts) {
  let fields = []
  for (let opt in postOpts) {
    if (opt === 'id') continue
    let formattedOpt = Object.assign(postOpts[opt])
    formattedOpt['name'] = opt
    switch (postOpts[opt].type) {
      case 'integer':
      case 'decimal':
        formattedOpt['fieldType'] = 'input'
        break
      case 'field':
        if (postOpts[opt].choices && postOpts[opt].choices.length) {
          formattedOpt['fieldType'] = 'select'
        } else {
          formattedOpt['fieldType'] = 'input'
          formattedOpt['autocomplete'] = true
          formattedOpt['searchAsync'] = true
          formattedOpt['triggerOnFocus'] = false
        }
        break
      default:
        formattedOpt['fieldType'] = postOpts[opt].type
    }
    delete formattedOpt.type
    fields.push(formattedOpt)
  }
  return fields
}



// WEBPACK FOOTER //
// ./src/utils/helpers/MapPostOptionsToFields.js